import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2766ca7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["tabindex"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    tabindex: _ctx.disabled ? -1 : 0,
    onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onGetFocus && _ctx.onGetFocus(...args))),
    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
    ref: "root",
    class: _normalizeClass(["ui-toggle-switcher", [{ disabled: _ctx.disabled, checked: _ctx.yesValue === _ctx.modelValue }, _ctx.type]])
  }, _hoisted_3, 42, _hoisted_1))
}